import { BToast } from 'bootstrap-vue'
import { faturaMixin } from '@/modules/faturas/mixins'
import util from '@/util'
import constants from '@/util/constants'
import arquivoUtil from '@/util/arquivoUtil'
import fileDownload from 'js-file-download'
import mensagens from '@/util/mensagens'

export default {
  name: 'DetalheFatura',
  props: {
    apenasLeitura: {
      type: Boolean,
      default: true
    },
    flagsDeControle: {
      type: Object,
      required: true
    },
    detalheFatura: {
      type: [Array, Object],
      default: () => [],
      required: true
    },
    cupomSelecionado: {
      type: [Array, Object],
      default: null
    },
    itensDaFatura: {
      type: [Array],
      default: () => []
    },
    visualizarNotaFiscalApi: {
      type: Function,
      required: true
    },
    baixarNotaFiscalApi: {
      type: Function,
      required: true
    }
  },
  components: {
    'b-toast': BToast
  },
  mixins: [faturaMixin],
  computed: {
    obterCorStatusCredito () {
      const classe = {
        1: 'cobranca-status-credito-pendente',
        2: 'cobranca-status-credito-realizado',
        3: 'cobranca-status-credito-recusado',
        1000: 'cobranca-status-credito-recusado',
        default: 'cobranca-status-credito-pendente'
      }
      return classe[this.fatura.status_id] ?? classe['default']
    },
    estaCarregandoDados () {
      return this.flagsDeControle.carregandoDados.status === true
    },
    obterDescricaoFatura () {
      if (!util.valorVazio(this.fatura.descricao)) {
        return this.fatura.descricao
      }
      return 'Mensalidade'
    },
    ehStatusFaturaPaga () {
      return this.fatura.status === constants.statusFatura.cobrancaPaga
    },
    podeCancelarFatura () {
      const statusPermitidosCancelamento = [
        constants.statusPagamento.pendente,
        constants.statusPagamento.erro,
        constants.statusPagamento.recusado,
        constants.statusPagamento.devolvido,
        null
      ]
      return (statusPermitidosCancelamento.includes(this.fatura.status_id)) && !this.ehContratacaoProdutoPrincipal && !this.ehStatusFaturaPaga
    },
    obterImagemBandeiraCartao () {
      const filtroPorCodigo = (codigo, bandeira) => bandeira.codigos.includes(codigo)
      const bandeiraEncontrada = this.obterBandeiraCartaoPorFiltro(+this.fatura.bandeira_cartao, filtroPorCodigo)
      if (!bandeiraEncontrada) return null
      return this.obterIconeBandeira(bandeiraEncontrada.nome)
    },
    possuiBandeiraCartao () {
      const bandeiraCartao = this.obterImagemBandeiraCartao
      return bandeiraCartao !== null
    },
    fatura: {
      get () {
        return this.detalheFatura
      },
      set (detalheFatura) {
        this.$emit('input', detalheFatura)
      }
    },
    flags: {
      get () {
        return this.flagsDeControle
      },
      set (flagsDeControle) {
        this.$emit('input', flagsDeControle)
      }
    },
    subTotal () {
      return this.itensDaFatura.reduce((total, item) => {
        const valorItem = item.valor || 0
        return total + (valorItem * item.quantidade)
      }, 0)
    },
    desconto () {
      return this.subTotal - this.fatura.valor_total
    },
    esconderBotoes () {
      return !this.apenasLeitura
    }
  },
  data: () => {
    return {
      feedbackLink: false,
      feedbackCodigo: false
    }
  },
  methods: {
    obterTotalPorPedido (item) {
      if (item.valor === null) {
        return 0
      }
      return item.valor * item.quantidade
    },
    formatarValorMonetario (valor, tipo = constants.tipoMonetario, total) {
      if (util.valorEhNulo(valor)) {
        return 'R$ 0'
      }
      if (tipo === constants.tipoMonetario) {
        return util.formatarValorMonetarioComCifrao(valor)
      } else if (tipo === constants.tipoPercentual) {
        // Converter percentual para valor monetário usando regra de três
        const valorConvertido = (valor / 100) * total
        return util.formatarValorMonetarioComCifrao(valorConvertido)
      }
    },
    formatarCartaoCredito (valor) {
      const utlimos4digitos = valor.slice(-4)
      return 'XXXX-XXXX-XXXX-' + utlimos4digitos
    },
    obterDescricaoStatusPagamento (codigoStatus) {
      switch (codigoStatus) {
        case 1:
          return 'Pagamento Pendente'
        case 2:
          return 'Pagamento Realizado'
        case 3:
          return 'Pagamento Recusado'
        case 4:
          return 'Pagamento Devolvido'
        case 1000:
          return 'Falha ao efetuar o pagamento'
        default:
          return 'Falha ao identificar o status do pagamento'
      }
    },
    calcularSubTotalDoItem (quantidade, valorUnitario) {
      valorUnitario = parseFloat(valorUnitario)
      quantidade = parseInt(quantidade)
      const subTotal = valorUnitario * quantidade
      return subTotal
    },
    copiarTexto (idElemento) {
      const elemento = document.getElementById(idElemento)
      const textoSelecionado = window.getSelection()
      const faixa = document.createRange()
      faixa.selectNodeContents(elemento)
      textoSelecionado.removeAllRanges()
      textoSelecionado.addRange(faixa)

      try {
        document.execCommand('copy')
        this[idElemento === 'linkPagamento' ? 'feedbackLink' : 'feedbackCodigo'] = true
        setTimeout(() => {
          this[idElemento === 'linkPagamento' ? 'feedbackLink' : 'feedbackCodigo'] = false
        }, 2000)
      } catch (err) {
        console.error('Erro ao copiar texto: ', err)
      }
    },
    async baixarBoleto (urlBoleto) {
      if (this.apenasLeitura) {
        return
      }
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        await arquivoUtil.downloadArquivoUrl(urlBoleto, 'boleto.pdf')
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },
    async baixarNotaFiscal (idFatura) {
      if (this.apenasLeitura) {
        return
      }
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.visualizarNotaFiscalApi(idFatura)
        fileDownload(resposta.data, 'nota_fiscal.xml')
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },
    async visualizarNotaFiscal (idFatura) {
      if (this.apenasLeitura) {
        return
      }
      const resposta = await this.axios.get(`/manager/conta/fatura/${idFatura}/download/nota_fiscal/pdf/configuracao/visualizar`, { responseType: 'blob' })
      const blob = new Blob([resposta.data], { type: 'application/pdf' })
      const pdfUrl = URL.createObjectURL(blob)

      window.open(pdfUrl, '_blank')
    },
    definirFlagCarregandoDados (status, mensagem) {
      this.flags.carregandoDados.status = status
      this.flags.carregandoDados.mensagem = mensagem
    }
  }
}
